/* Nextro – Corporate Gifting page scripts */
(function () {
  'use strict';

  /* ---------- Countdown + days-left text ---------- */
  function timeLeft(deadline) {
    var end = Date.parse(deadline);
    if (isNaN(end)) return null;
    var ms = Math.max(0, end - Date.now());
    return {
      total: ms,
      days: Math.floor(ms / 86400000),
      hours: Math.floor((ms % 86400000) / 3600000),
      mins: Math.floor((ms % 3600000) / 60000),
      secs: Math.floor((ms % 60000) / 1000)
    };
  }
  var pad = function (n) { return String(n).padStart(2, '0'); };

  document.querySelectorAll('[data-cg-countdown]').forEach(function (el) {
    var deadline = el.getAttribute('data-deadline');
    var units = {};
    el.querySelectorAll('[data-unit]').forEach(function (u) { units[u.getAttribute('data-unit')] = u; });
    function tick() {
      var t = timeLeft(deadline);
      if (!t) return;
      ['days', 'hours', 'mins', 'secs'].forEach(function (k) { if (units[k]) units[k].textContent = pad(t[k]); });
      if (t.total > 0) setTimeout(tick, 1000);
    }
    tick();
  });

  document.querySelectorAll('[data-cg-days-left]').forEach(function (el) {
    var t = timeLeft(el.getAttribute('data-deadline'));
    if (!t) return;
    if (t.total <= 0) { el.textContent = 'orders for Diwali delivery have closed'; return; }
    var d = Math.ceil(t.total / 86400000);
    var suffix = el.hasAttribute('data-suffix') ? el.getAttribute('data-suffix') : ' left for guaranteed delivery';
    el.textContent = d + (d === 1 ? ' day' : ' days') + suffix;
  });

  /* ---------- Sticky bottom bar ---------- */
  var sticky = document.querySelector('[data-cg-sticky]');
  if (sticky) {
    var setVisible = function (on) {
      sticky.classList.toggle('is-visible', on);
      if (on) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
    };
    if (window.Shopify && window.Shopify.designMode) {
      setVisible(true);
    } else {
      // Show once the hero (which holds the quote form) has scrolled away; hide while the footer is on screen
      var hero = document.querySelector('.cg-hero');
      var blockers = Array.prototype.slice.call(document.querySelectorAll('#cg-quote, .cg-footer'));
      var queued = false;
      var update = function () {
        queued = false;
        var vh = window.innerHeight;
        var pastHero = hero ? hero.getBoundingClientRect().bottom < 0 : true;
        var blocked = blockers.some(function (b) { var r = b.getBoundingClientRect(); return r.top < vh && r.bottom > 0; });
        setVisible(pastHero && !blocked);
      };
      var onScroll = function () { if (!queued) { queued = true; requestAnimationFrame(update); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      sticky.cgUpdate = update; // lets QA scripts re-check without waiting for a frame
      update();
    }
  }

  /* ---------- Catalogue pop-up ----------
     The catalogue buttons open a short form; once it is sent, the catalogue opens in a new tab.
     Uses event delegation so it keeps working when the theme editor re-renders the section. */
  var catalogueUrl = '';
  var reloadOnClose = false;
  var dialogEl = function () { return document.querySelector('[data-cg-catalogue-dialog]'); };
  var canDialog = function (d) { return d && typeof d.showModal === 'function'; };

  function openCatalogue(url) {
    var d = dialogEl();
    if (!canDialog(d)) return false;
    catalogueUrl = url || catalogueUrl;
    var f = d.querySelector('form');
    var done = d.querySelector('[data-cg-dialog-done]');
    var err = d.querySelector('[data-cg-dialog-error]');
    var btn = f.querySelector('[type="submit"]');
    f.hidden = false; done.hidden = true; err.hidden = true;
    btn.disabled = false; btn.removeAttribute('aria-busy');
    if (!d.open) d.showModal();
    document.documentElement.classList.add('cg-no-scroll');
    return true;
  }

  function showCatalogueDone(d) {
    var f = d.querySelector('form');
    var done = d.querySelector('[data-cg-dialog-done]');
    f.reset(); f.hidden = true; done.hidden = false;
    if (catalogueUrl) d.querySelector('[data-cg-dialog-open]').setAttribute('href', catalogueUrl);
    done.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cg-catalogue]');
    if (trigger && canDialog(dialogEl())) {
      e.preventDefault();
      openCatalogue(trigger.getAttribute('href'));
      return;
    }
    var d = dialogEl();
    if (!d) return;
    if (e.target === d || e.target.closest('[data-cg-dialog-close]')) d.close();
  });

  // the dialog's close event does not bubble, so listen in the capture phase
  document.addEventListener('close', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-cg-catalogue-dialog]')) {
      document.documentElement.classList.remove('cg-no-scroll');
      // after a page-reload submit the quote form above shows a thank-you meant for the other form: start the page clean
      if (reloadOnClose) window.location.replace(window.location.pathname);
    }
  }, true);

  /* The form is sent the normal way, never with a script-made request: Shopify's spam protection (hCaptcha) hooks every
     contact form, adds its token and then submits the form itself, so a request made from here would have no token and be
     turned away. On submit we only open the catalogue tab (that needs this click) and remember it; Shopify sends the form and
     the page comes back with ?contact_posted=true, which is when the tab is pointed at the catalogue. */
  var TAB_NAME = 'cg-catalogue-tab';
  var SENT_KEY = 'cgCatalogueSent';
  var GIVE_UP_MS = 45000;

  function setBusy(form, on) {
    var btn = form.querySelector('[type="submit"]');
    btn.disabled = on;
    if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-cg-catalogue-form]')) return;

    var d = dialogEl();
    var err = d.querySelector('[data-cg-dialog-error]');

    // Open the tab now, while the click still counts as a user action
    var tab = window.open('', TAB_NAME);
    if (tab) {
      try {
        tab.document.title = 'Nextro catalogue';
        tab.document.body.style.cssText = 'font:16px system-ui,sans-serif;padding:32px;color:#5a4636';
        tab.document.body.textContent = 'Preparing your catalogue\u2026 If this page stays empty, go back to the Nextro page and use the "Open the catalogue" button.';
      } catch (x) { /* ignore */ }
    }
    try { window.sessionStorage.setItem(SENT_KEY, '1'); } catch (x) { /* ignore */ }

    err.hidden = true;
    setBusy(form, true);

    var timer = setTimeout(function () {
      if (observer) observer.disconnect();
      if (tab && !tab.closed) tab.close();
      try { window.sessionStorage.removeItem(SENT_KEY); } catch (x) { /* ignore */ }
      err.hidden = false;
      setBusy(form, false);
    }, GIVE_UP_MS);

    // Shopify's spam protection can still be loading: it holds this submit back, so send it again once it is ready
    var observer = null;
    if (e.defaultPrevented && !form.hasAttribute('data-hcaptcha-bound') && window.MutationObserver) {
      observer = new MutationObserver(function () {
        if (!form.hasAttribute('data-hcaptcha-bound')) return;
        observer.disconnect();
        clearTimeout(timer);
        setBusy(form, false);
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
      observer.observe(form, { attributes: true, attributeFilter: ['data-hcaptcha-bound'] });
    }
  });

  // Back from the submit (the page was reloaded with the result in the address)
  if (window.location.hash === '#cg-catalogue-form' && canDialog(dialogEl())) {
    var postedBack = /[?&]contact_posted=true/.test(window.location.search);
    var firstTrigger = document.querySelector('[data-cg-catalogue]');
    if (postedBack || dialogEl().querySelector('[data-cg-form-errors]')) {
      openCatalogue(firstTrigger ? firstTrigger.getAttribute('href') : '');
      if (postedBack) {
        showCatalogueDone(dialogEl());
        reloadOnClose = true;
        var wasSent = false;
        try { wasSent = !!window.sessionStorage.getItem(SENT_KEY); window.sessionStorage.removeItem(SENT_KEY); } catch (x) { /* ignore */ }
        // point the tab that was opened at submit (or a new one, if the browser allows it) at the catalogue
        if (wasSent && catalogueUrl && catalogueUrl !== '#') {
          var sentTab = window.open('', TAB_NAME);
          if (sentTab) { try { sentTab.location.href = catalogueUrl; } catch (x) { /* ignore */ } }
        }
      }
    }
  }

  // theme editor: show the pop-up while its section is selected
  document.addEventListener('shopify:section:select', function (e) {
    var d = dialogEl();
    if (d && e.target.contains(d)) openCatalogue(catalogueUrl || '#');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var d = dialogEl();
    if (d && e.target.contains(d) && d.open) d.close();
  });

  /* ---------- Hero quote form ---------- */
  var form = document.getElementById('cg-quote-form');
  if (!form) return;

  // After a successful send Shopify reloads the page with the form id in the URL: bring the thank-you message into view
  var success = form.querySelector('[data-cg-success]');
  if (success) {
    success.scrollIntoView({ block: 'center' });
    success.focus({ preventScroll: true });
    return;
  }

  /* ---------- Product card → pre-fill the form ---------- */
  var interest = form.querySelector('[data-cg-interest]');
  var giftSelect = form.querySelector('[data-cg-gift-select]');

  document.querySelectorAll('[data-cg-pick]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (interest) interest.value = btn.getAttribute('data-cg-pick-name') || '';

      var gift = (btn.getAttribute('data-cg-gift') || '').toLowerCase();
      if (giftSelect && gift) {
        Array.prototype.some.call(giftSelect.options, function (opt) {
          if (opt.value.toLowerCase() === gift) { giftSelect.value = opt.value; return true; }
          return false;
        });
      }

      // The link scrolls to the form; move focus to the first field once it is in view
      var first = form.querySelector('input:not([type="hidden"])');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 500);
    });
  });
})();
